import React from "react";
import Hero from "../components/Hero";
import Stats from "../components/Stats";
import ZonesSection from "../components/zones";

const Landing = () => {
  return (
    <div
      className="min-h-screen w-full flex flex-col"
      style={{ background: "#f6f6f6", fontFamily: "'Open Sans', sans-serif" }}
    >
      <Hero />
      <div className="mt-3 mx-auto w-full" style={{ maxWidth: "1440px" }}>
        <Stats />
        <ZonesSection />
      </div>
    </div>
  );
};

export default Landing;
